export default "__VITE_ASSET__DV2j4gvp__"